import React, { useState, useEffect } from 'react';
import { NAV_LINKS, INSTITUTIONAL_INFO } from '../constants';

const Navbar: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    let ticking = false;
    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          setIsScrolled(window.scrollY > 50);
          ticking = false;
        });
        ticking = true;
      }
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navClassName = isScrolled
    ? 'bg-brand-darkGreen/95 backdrop-blur-md shadow-lg py-2'
    : 'bg-brand-darkGreen/20 backdrop-blur-[2px] py-3';

  const logoClassName = isScrolled
    ? 'h-12 md:h-14'
    : 'h-14 md:h-16 lg:h-[72px]';

  return (
    <nav
      className={`fixed w-full z-50 top-0 left-0 transition-all duration-300 ${navClassName}`}
      style={{ transform: 'translateZ(0)', willChange: 'padding, background-color' }}
    >
      <div className="max-w-7xl mx-auto px-4 flex justify-between items-center">

        <a href="#" className="block transition-transform duration-300 hover:scale-[1.02]" aria-label="Ir para o início">
          <div className="flex items-center gap-2">
            <img
              src="/assets/logo_litoral.png"
              alt="Logo ACONTURS Litoral"
              className={`${logoClassName} w-auto object-contain transition-all duration-300`}
            />
          </div>
        </a>

        <div className="hidden lg:flex items-center lg:gap-4 xl:gap-6">
          {NAV_LINKS.map((link) => (
            <a
              key={link.name}
              href={link.href}
              className="text-white/85 hover:text-brand-yellow font-bold text-xs xl:text-sm tracking-wider uppercase transition-colors"
            >
              {link.name}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-2 sm:gap-3">
          <a
            href={INSTITUTIONAL_INFO.appLink}
            className="hidden md:flex bg-white text-brand-darkGreen px-3 py-2 rounded-lg font-bold text-xs uppercase hover:bg-slate-100 transition shadow-lg items-center gap-2"
          >
            <i className="fas fa-sign-in-alt"></i>
            Fazer login
          </a>

          <a
            href="https://wa.me/5551982755065"
            target="_blank"
            rel="noreferrer"
            className="bg-brand-yellow text-brand-darkGreen px-4 md:px-5 py-2.5 rounded-lg font-bold text-sm hover:bg-yellow-400 transition shadow-lg btn-shine flex items-center gap-2"
          >
            <i className="fas fa-user-plus"></i>
            <span className="hidden sm:inline">FILIE-SE</span>
          </a>
        </div>

      </div>
    </nav>
  );
};

export default Navbar;
